import { useQuery } from "@tanstack/react-query";

import { BusinessTicketRequestService } from "../../../../../services/company-office/BusinessTicketService";
// import { useSelector } from "../../../../../store/store";
import { requestStatus } from "../../../../../constants";
import { useSelector } from "../../../../../store/store";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";

export const useBusinessTicketsRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["business-tickets-requests"],
    queryFn: () => BusinessTicketRequestService.getBusinessTicketRequests(userEmail),
  });

  const businessTicketsMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase(),
  );

  const mappedBusinessTicketsRequests = data
    .map((record) => {
      const status = getStatusBaseOnApprover(record.fields, userEmail);
      const step = getStepBaseOnApprover(record.fields, userEmail);

      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedBusinessTicketsMyRequests = mappedBusinessTicketsRequests
    .filter((record) => {
      const isCreatedByUser = record.createdByEmail.toLowerCase() === userEmail.toLowerCase();
      if (!isCreatedByUser) return false;

      // Lọc theo điều kiện: ngày hiện tại - 7 ngày >= record.eFinishTime
      if (record.eFinishTime) {
        const currentDate = new Date();
        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const finishTime = new Date(record.eFinishTime);

        return finishTime >= sevenDaysAgo;
      }

      return true;
    })
    .sort((a, b) => {
      const aPins = JSON.parse(a.ePins || "[]");
      const bPins = JSON.parse(b.ePins || "[]");

      const hasMineInaPins = aPins.includes(userEmail?.toLowerCase());
      const hasMineInbPins = bPins.includes(userEmail?.toLowerCase());

      if (hasMineInaPins && !hasMineInbPins) return -1;
      if (!hasMineInaPins && hasMineInbPins) return 1;

      return b.id - a.id;
    });

  const guideLink = "https://drive.google.com/file/d/1KF1zPqvLZ5TJ1XloGFtlMJw1Jy03o7iM/view?usp=drive_link";

  // yêu cầu cần duyệt
  const businessTicketsRequestsNeedToApprove = mappedBusinessTicketsRequests
    .filter((item) => {
      try {
        if (item?.eRequestStatus !== requestStatus.submitted) return false;

        const steps = JSON.parse(item?.eSteps || "[]") || [];

        const stepsLength = steps.length;

        if (!stepsLength) return false;

        const handledStepIndex = steps.findLastIndex((step: any) =>
          step.some((approver: any) => approver.isApproved || approver.isRejected),
        );

        if (handledStepIndex === -1) return false;
        if (handledStepIndex === stepsLength - 1) return false;

        const nextStep = steps[handledStepIndex + 1];

        if (!nextStep) return false;

        return nextStep.some((approver: any) => approver.email.toLowerCase() === userEmail.toLowerCase());
      } catch (error) {
        return false;
      }
    })
    .sort((a, b) => {
      const aPins = JSON.parse(a.ePins || "[]");
      const bPins = JSON.parse(b.ePins || "[]");

      const hasMineInaPins = aPins.includes(userEmail?.toLowerCase());
      const hasMineInbPins = bPins.includes(userEmail?.toLowerCase());

      if (hasMineInaPins && !hasMineInbPins) return -1;
      if (!hasMineInaPins && hasMineInbPins) return 1;

      return b.id - a.id;
    });

  return {
    ...restResponse,
    guideLink,
    businessTicketsRequestsNeedToApprove,
    businessTicketsRequests: data,
    businessTicketsMyRequests,
    mappedBusinessTicketsRequests,
    mappedBusinessTicketsMyRequests,
  };
};
